import React, { useState, useRef } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Typography,
  Box,
  Divider,
  Card,
  CardContent,
  Grid,
  MenuItem,
  Select
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  KeyboardArrowDown,
  Remove as RemoveIcon,
  Search as SearchIcon
} from '@material-ui/icons';
import WebsiteHeader from '../../header/2025/WebsiteHeader';
import '../../../assets/styles/component/customer/Bulk/BulkOrderPage.scss';
import img from '../../../assets/images/Products_Images/2cd43b_0edde190f9eb4ffbb669f6de80034d54_mv2_d_1280_1230_s_2.png'
import img1 from '../../../assets/images/Products_Images/2cd43b_1253868455ff42ef97513b70d65a3f21_mv2.png'
import img2 from '../../../assets/images/Products_Images/2cd43b_3db08e46b877415c8de6bb208c9d05d1_mv2.png'
import img3 from '../../../assets/images/Products_Images/2cd43b_8cde352199ec41958100ae808bea9c51_mv2.png'
import img4 from '../../../assets/images/Products_Images/2cd43b_e1762ed5d54a431b868a924379c3e059_mv2.png'
import img5 from '../../../assets/images/Products_Images/2cd43b_a4430f72c31e4fbe82d1dfe5be11ff8e_mv2.png'

const BulkOrderPage = () => {
  const products = [
    {
      sku: '243598234',
      image: img,
      brand: 'BKLGO',
      name: 'Full Zip Hoodie',
      variants: ['Gray', 'Black', 'White', 'Blue'],
      selectedVariant: 'Gray',
      price: 1321,
      descPrice: 999,
      quantity: 0,
      status: 'OUT OF STOCK'
    },
    {
      sku: '9912834',
      image: img1,
      brand: 'Gray Living',
      name: 'Chair',
      variants: ['Wood', 'Metal', 'Plastic'],
      selectedVariant: 'Wood',
      price: 2099,
      descPrice: 1899,
      quantity: 32,
      status: 'IN STOCK'
    },
    {
      sku: '01827391',
      image: img2,
      brand: 'Dolce & Gabbana',
      name: 'Skirt',
      variants: ['Black', 'Red', 'Navy'],
      selectedVariant: 'Black',
      price: 999,
      descPrice: 899,
      quantity: 0,
      status: 'OUT OF STOCK'
    },
    {
      sku: '928341',
      image: img3,
      brand: 'Heron Preston',
      name: 'T-shirt',
      variants: ['White', 'Black', 'Gray'],
      selectedVariant: 'White',
      price: 149,
      descPrice: 99,
      quantity: 0,
      status: 'OUT OF STOCK'
    },
    {
      sku: '877712',
      image: img4,
      brand: 'Apple',
      name: 'MacBook Pro',
      variants: ['16-inch', '14-inch', '13-inch'],
      selectedVariant: '16-inch',
      price: 1869,
      descPrice: 1699,
      quantity: 0,
      status: 'OUT OF STOCK'
    },
    {
      sku: '634729',
      image: img5,
      brand: 'Fendi',
      name: 'Gradient Coat',
      variants: ['Blue', 'Green', 'Red'],
      selectedVariant: 'Blue',
      price: 869,
      descPrice: 799,
      quantity: 725,
      status: 'IN STOCK'
    },
    {
      sku: '634730',
      image: img2,
      brand: 'Y-3',
      name: 'Yohji Yamamoto',
      variants: ['Black', 'White', 'Gray'],
      selectedVariant: 'Black',
      price: 599,
      descPrice: 499,
      quantity: 42,
      status: 'IN STOCK'
    }
  ];

  const [cart, setCart] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedQuantities, setSelectedQuantities] = useState({});
  const [productsPerPage, setProductsPerPage] = useState(5);
  const [productList, setProductList] = useState(products);
  const inputRef = useRef(null);

  const filteredProducts = productList.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.brand.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.sku.includes(searchTerm) ||
    product.selectedVariant.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  const handlePageChange = (event, value) => setCurrentPage(value);

  const handleQuantityChange = (sku, value) => {
    if (value === '') {
      setSelectedQuantities(prev => ({
        ...prev,
        [sku]: ''
      }));
      return;
    }
    
    const numValue = parseInt(value) || 0;
    setSelectedQuantities(prev => ({
      ...prev,
      [sku]: numValue >= 0 ? numValue : 0
    }));
  };

  const handleVariantChange = (sku, variant) => {
    setProductList(prevProducts => 
      prevProducts.map(product => 
        product.sku === sku ? { ...product, selectedVariant: variant } : product
      )
    );
  };

  const addToCart = (product) => {
    const qty = selectedQuantities[product.sku] || 0;
    if (product.quantity > 0 && qty > 0) {
      const existingItem = cart.find(item => 
        item.sku === product.sku && item.selectedVariant === product.selectedVariant
      );
      if (existingItem) {
        setCart(cart.map(item =>
          item.sku === product.sku && item.selectedVariant === product.selectedVariant 
            ? { ...item, qty: qty } 
            : item
        ));
      } else {
        setCart([...cart, {
          sku: product.sku,
          name: product.name,
          brand: product.brand,
          selectedVariant: product.selectedVariant,
          price: product.price,
          descPrice: product.descPrice,
          qty: qty,
          image: product.image
        }]);
      }
    }
  };

  const removeFromCart = (sku, variant) => {
    setCart(cart.filter(item => !(item.sku === sku && item.selectedVariant === variant)));
  };

  const updateQuantity = (sku, variant, newQty) => {
    if (newQty < 1) {
      removeFromCart(sku, variant);
      return;
    }
    setCart(cart.map(item =>
      item.sku === sku && item.selectedVariant === variant ? { ...item, qty: newQty } : item
    ));
  };

  const subtotal = cart.reduce((sum, item) => sum + (item.descPrice * item.qty), 0);

  return (
    <div className='bulk-container'>
      <WebsiteHeader />
      <Box className="bulk-order-container ">
        <h1 className='bulk-heading'>Bulk Order</h1>
        <Grid container spacing={3} className="bulk-order-grid-container">
          {/* Left side - Product List */}
          <Grid item xs={9} md={8.5} className="product-list-container">
            <Card className="product-list-card">
              <CardContent className="product-list-card-content">
                {/* Top Bar with Entries Dropdown and Search */}
                <Box className="flex-between top-bar-container">
                  {/* Entries per page dropdown */}
                  <Box className="flex-align-center entries-dropdown-container">
                    <TextField
                      select
                      value={productsPerPage}
                      onChange={(e) => {
                        setProductsPerPage(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                      variant="outlined"
                      size="small"
                      className="entries-dropdown"
                      SelectProps={{
                        native: true,
                      }}
                    >
                      {[5, 10, 25, 50, 100].map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </TextField>
                    <Typography variant="body2" className="entries-text">Entries per page</Typography>
                  </Box>

                  {/* Search Bar */}
                  <TextField
                    variant="outlined"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    className="search-bar"
                    size="small"
                  />
                </Box>

                {/* Product Table */}
                <TableContainer component={Paper} className="product-table" elevation={0}>
                  <Table>
                    <TableHead>
                      <TableRow className="table-header-row">
                        <TableCell className="table-header-cell">Image</TableCell>
                        <TableCell className="table-header-cell">SKU</TableCell>
                        <TableCell className="table-header-cell product-title-cell">Product Title</TableCell>
                        <TableCell className="table-header-cell">Brand</TableCell>
                        <TableCell className="table-header-cell">Variant</TableCell>
                        <TableCell className="table-header-cell">Price</TableCell>
                        <TableCell className="table-header-cell">Disc. Price</TableCell>
                        <TableCell className="table-header-cell quantity-cell">Qty</TableCell>
                        <TableCell className="table-header-cell action-cell">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {currentProducts.length > 0 ? (
                        currentProducts.map((product, index) => (
                          <TableRow 
                            key={product.sku} 
                            className={`table-body-row ${index === currentProducts.length - 1 ? 'last-row' : ''}`}
                          >
                            <TableCell className="table-body-cell">
                              <img 
                                src={product.image} 
                                alt={product.name} 
                                className="product-image"
                              />
                            </TableCell>
                            <TableCell className="table-body-cell">{product.sku}</TableCell>
                            <TableCell className="table-body-cell product-title-cell">{product.name}</TableCell>
                            <TableCell className="table-body-cell">{product.brand}</TableCell>
                            <TableCell className="table-body-cell">
                              <Select
                                value={product.selectedVariant}
                                onChange={(e) => handleVariantChange(product.sku, e.target.value)}
                                className="variant-select"
                                disabled={product.quantity === 0}
                                disableUnderline
                                style={{
                                  border: 'none',
                                  backgroundColor: 'transparent'
                                }}
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      marginTop: '5px',
                                      boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'
                                    }
                                  }
                                }}
                              >
                                {product.variants.map(variant => (
                                  <MenuItem key={variant} value={variant}>{variant}</MenuItem>
                                ))}
                              </Select>
                            </TableCell>
                            <TableCell className="table-body-cell">${product.price.toFixed(2)}</TableCell>
                            <TableCell className="table-body-cell">${product.descPrice.toFixed(2)}</TableCell>
                            <TableCell className="table-body-cell quantity-cell">
                              <TextField
                                type="number"
                                value={
                                  selectedQuantities[product.sku] === undefined 
                                    ? '0' 
                                    : selectedQuantities[product.sku] === 0 && document.activeElement !== inputRef.current 
                                      ? '0' 
                                      : selectedQuantities[product.sku] || ''
                                }
                                onChange={(e) => handleQuantityChange(product.sku, e.target.value)}
                                onFocus={(e) => {
                                  if (selectedQuantities[product.sku] === 0 || selectedQuantities[product.sku] === undefined) {
                                    handleQuantityChange(product.sku, '');
                                  }
                                }}
                                onBlur={(e) => {
                                  if (e.target.value === '') {
                                    handleQuantityChange(product.sku, 0);
                                  }
                                }}
                                inputProps={{
                                  min: 0,
                                  className: 'quantity-input',
                                  ref: inputRef
                                }}
                                variant="outlined"
                                size="small"
                                disabled={product.quantity === 0}
                                className="quantity-field"
                              />
                            </TableCell>
                            <TableCell className="table-body-cell action-cell">
                              <Button
                                variant="contained"
                                color={product.quantity > 0 ? "primary" : "default"}
                                onClick={() => addToCart(product)}
                                disabled={product.quantity <= 0 || (selectedQuantities[product.sku] || 0) <= 0}
                                size="small"
                                className={`action-button ${product.quantity > 0 ? 'add-to-cart-button' : 'out-of-stock-button'}`}
                                style={{
                                  backgroundColor: product.quantity > 0 ? '' : '#f5f5f5'
                                }}
                              >
                                {product.quantity > 0 ? "Add to Cart" : "Out of Stock"}
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow className="no-products-row">
                          <TableCell colSpan={9} className="text-center no-products-cell">
                            No products found matching your search
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Bottom Bar with entries info and pagination */}
                <Box className="flex-between bottom-bar-container">
                  <Typography variant="body2" className="entries-info">
                    Showing {indexOfFirstProduct + 1} to {Math.min(indexOfLastProduct, filteredProducts.length)} of {filteredProducts.length} entries
                  </Typography>
                  
                  {filteredProducts.length > productsPerPage && (
                    <Pagination
                      count={Math.ceil(filteredProducts.length / productsPerPage)}
                      page={currentPage}
                      onChange={handlePageChange}
                      color="primary"
                      shape="rounded"
                      className="pagination-container"
                      classes={{
                        root: 'pagination-root',
                        rounded: 'pagination-rounded',
                      }}
                    />
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Right side - Cart Summary */}
          <Grid item xs={3} md={3.5} className="cart-summary-container">
            <Card className="cart-summary-card">
              <CardContent className="cart-summary-content">
                <Typography variant="h6" gutterBottom className="cart-title">
                  Your Cart ({cart.length})
                </Typography>
                
               
                <Divider className="summary-divider" />

                {/* Cart Items */}
                <Box className="cart-items-container">
                  {cart.length > 0 ? (
                    cart.map((item) => (
                      <Box key={`${item.sku}-${item.selectedVariant}`} className="cart-item">
                        <Grid container spacing={1}>
                          <Grid item xs={3}>
                            <img src={item.image} alt={item.name} className="cart-item-image" />
                          </Grid>
                          <Grid item xs={9}>
                            <Typography variant="body2" className="cart-item-title">
                              {item.brand} {item.name}
                            </Typography>
                            <Typography variant="body2" className="cart-item-variant">
                              {item.selectedVariant}
                            </Typography>
                            <Typography variant="body2" className="cart-item-price">
                              ${item.descPrice.toFixed(2)} x {item.qty} = ${(item.descPrice * item.qty).toFixed(2)}
                            </Typography>
                            <Box className="flex-align-center quantity-control-container">
                              <IconButton 
                                size="small"
                                onClick={() => updateQuantity(item.sku, item.selectedVariant, item.qty - 1)}
                                className="quantity-button"
                              >
                                <RemoveIcon fontSize="small" />
                              </IconButton>
                              <Typography variant="body1" className="quantity-value">
                                {item.qty}
                              </Typography>
                              <IconButton 
                                size="small"
                                onClick={() => updateQuantity(item.sku, item.selectedVariant, item.qty + 1)}
                                className="quantity-button"
                              >
                                <AddIcon fontSize="small" />
                              </IconButton>
                              <IconButton 
                                size="small"
                                onClick={() => removeFromCart(item.sku, item.selectedVariant)}
                                className="delete-button"
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    ))
                  ) : (
                    <Typography variant="body2" className="empty-cart-message">
                      Your cart is empty
                    </Typography>
                  )}
                </Box>

                {/* Order Summary */}
                {cart.length > 0 && (
                  <>
                    <Divider className="summary-divider" />
                     <Typography variant="subtitle1" gutterBottom className="mt-2 order-summary-title">
                      Order Summary
                    </Typography>
                    <Divider className="summary-divider" />
                    <Box className="flex-between summary-row">
                      <Typography className="summary-label">Subtotal</Typography>
                      <Typography className="summary-value">${subtotal.toFixed(2)}</Typography>
                    </Box>
                    <Divider className="summary-divider" />
                    <Box className="flex-between summary-row">
                      <Typography className="summary-label">Cashback</Typography>
                      <Typography className="summary-value">$0.00</Typography>
                    </Box>
                    <Divider className="summary-divider" />
                    <Box className="flex-between summary-row">
                      <Typography className="summary-label">Please add a Coupon to Apply</Typography>
                      <KeyboardArrowDown className="summary-arrow" />
                    </Box>
                    <Divider className="summary-divider" />
                    <Box className="flex-between summary-row">
                      <Typography className="summary-label">View Available Offers</Typography>
                      <KeyboardArrowDown className="summary-arrow" />
                    </Box>

                    <Button 
                      variant="contained"
                      fullWidth
                      className="checkout-button"
                      disabled={cart.length === 0}
                    >
                      Proceed to Checkout
                    </Button>
                  </>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default BulkOrderPage;